export function mapStateToLists (playlists, entities) {
  return playlists.lists && playlists.lists.map(id => {
    const list = entities.playlists[id]
    return {
      ...list,
      albums: JSON.parse(list.json_data).albums
        .map(item => entities.albums[item.album])
        .filter(a => a)
    }
  })
}

export function updateAlbumLists ({ albumID, checked, createList, lists, addAlbumToList, removeAlbumFromList, saveList }) {
  let promises = []
  if (checked) {
    lists.forEach(list => {
      const isChecked = checked.indexOf(list.id) !== -1
      const inList = list.albums.map(a => a.id).indexOf(albumID) !== -1
      if (isChecked && !inList) {
        // console.log('adding', albumID, 'to', list.id)
        promises.push(addAlbumToList(albumID, list))
      }
      if (!isChecked && inList) {
        // console.log('removing', albumID, 'from', list.id)
        promises.push(removeAlbumFromList(albumID, list))
      }
    })
  }
  if (createList) {
    const structure = { albums: [ { album: albumID } ] }
    promises.push(saveList({ name: createList }, structure, null, null))
  }
  return Promise.all(promises)
}



// WEBPACK FOOTER //
// ./src/utils/lists.js